import {Component, inject, Signal} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

import {ReportsService} from '../../services/reports.service';
import {RouterLink} from '@angular/router';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {toSignal} from '@angular/core/rxjs-interop';
import {SanitizePipe} from '../../shared/pipes/sanitize.pipe';
import {PageHeaderComponent} from '../../shared/components/page-templates/page-header/page-header.component';
import {PageFooterComponent} from '../../shared/components/page-templates/page-footer/page-footer.component';
import {ReportGroup} from './classes/report-group';
import {MatButton} from '@angular/material/button';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';

@Component({
  selector: 'tgrid-reports',
  imports: [
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatInputModule,
    MatTooltipModule,
    MatMenuModule,
    SanitizePipe,
    PageHeaderComponent,
    PageFooterComponent,
    MatButton,
    RouterLink,
    VulcanIconComponent,
],
  templateUrl: './reports.component.html',
  standalone: true,
  styleUrl: './reports.component.scss',
})
export class ReportsComponent {

  protected reportGroups: Signal<ReportGroup[]> = toSignal(inject(ReportsService).fetchReports(), {initialValue: []});


  // protected filterGroup: FormGroup = new FormGroup({
  //   search: new FormControl<string>(''),
  //   groups: new FormControl<string[]>([])
  // });

  // protected filterValue: Signal<Partial<{
  //   search: string,
  //   groups: string[]
  // }>> = toSignal(this.filterGroup.valueChanges);


  // protected allReports = toSignal(this.reports$, {initialValue: []});
  // protected visibleReports = computed(() => {
  //   if (this.filterValue() === undefined) return this.allReports();
  //
  //   return this.allReports().filter(report => {
  //     const nameCheck = (this.filterValue().search) ? report.displayName.toLowerCase().includes(this.filterValue().search!.toLowerCase()) : true
  //     const groupCheck = (this.filterValue()?.groups!.length !== 0) ? this.filterValue().groups!.includes(report.groupIcon) : true
  //     return nameCheck && groupCheck;
  //   });
  //
  // })
  //
  //
  // private router = inject(Router);
  //
  //
  // public goToReport(report: Report) {
  //   this.filterGroup.valueChanges.subscribe(r => {
  //
  //   })
  //   const endpoint = report.serviceUrl;
  //   // noinspection JSIgnoredPromiseFromCall
  //   this.router.navigate(['app/reports', `${endpoint}`]);
  // }

  protected readonly ReportGroup = ReportGroup;
}
